import { RequestService } from '@tcc-online/request-service';

const PATH = '/participant';

const DemographicService = {
    getData,
    postAnswer,
};

async function getData() {
    return await RequestService.get(`${PATH}/demographic-criteria`);
}

async function postAnswer(values: any[]) {
    return await RequestService.post(
        `${PATH}/demographic-criterion-values`,
        values,
    );
}

export default DemographicService;
